import { useEffect, useRef } from 'react';
import type { Editor } from '@meitu/saas-editor-core';
import type { EventEmitter } from '@meitu/saas-editor-core/es/framework';
import { IExtraInfo, ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import { getCalculatePrice } from '@meitu/xdesign-widgets/dist/meidouInfo/utils';

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_PRICE = 'UPDATE_PRICE';

type UseGeneratePPTProps = {
    prompt: string;
    setPrompt: (prompt: string) => void;
    tip: string;
    btnUuid?: string;
    needUpdate?: boolean;
    setNeedUpdate?: (needUpdate: boolean) => void;
    recordId: string;
    setIsAiCreate: (isAiCreate: boolean) => void;
    setAiRegen: (data: { isAiRegen: boolean; regenIndex?: number }) => void;
    editor: Editor;
    events: EventEmitter;
    // import { useCreateTipHelper } from '@/editor/components/pptCreateTip';
    // const createTipHelper = useCreateTipHelper(); createTipHelper.show()
    showCreateTip: (tip: string) => void;
    // import { useCreateTipHelper } from '@/editor/components/pptCreateTip';
    // const createTipHelper = useCreateTipHelper(); createTipHelper.hide()
    hideCreateTip: () => void;
    // import { transferTemplateToClient } from '@/hooks/useFetchTemplate/initTemplate';
    transferTemplateToClient: (templateDetail: any, fontList: any) => Promise<any>;
    // import { packageTemplateConf } from '@/hooks/useFetchTemplate';
    packageTemplateConf: (
        templateConf: any,
        extraInfo: IExtraInfo,
        init: boolean,
    ) => {
        stages: ILayerProps[][];
        extraInfos: IExtraInfo[];
    };
    templateSubject: string;
    // import { fetchPPTApplyItem } from '@/services';
    fetchPPTApplyItem: (params: any) => Promise<any>;
    // import { fetchPPTCheckItemProcess } from '@/services';
    fetchPPTCheckItemProcess: (params: any) => Promise<any>;
    // import { fetchPPTItemDetail } from '@/services';
    fetchPPTItemDetail: (params: any) => Promise<any>;
};

export const useGeneratePPT = ({
    editor,
    events,
    prompt,
    setPrompt,
    tip,
    btnUuid = '',
    needUpdate = false,
    setNeedUpdate,
    recordId,
    setIsAiCreate,
    setAiRegen,
    showCreateTip,
    hideCreateTip,
    transferTemplateToClient,
    templateSubject,
    fetchPPTApplyItem,
    fetchPPTCheckItemProcess,
    fetchPPTItemDetail,
    packageTemplateConf,
}: UseGeneratePPTProps) => {
    const params = {
        prompt,
        record_id: recordId,
        type: 2,
        title: templateSubject,
    };

    const reCalculatePrice = (updateMeidou = true) => {
        getCalculatePrice(
            {
                subfunc: 'ai_ppt_item',
                task_param: JSON.stringify(params),
            },
            btnUuid,
        );
        updateMeidou && events.emit(UPDATE_USER_INFO);
    };

    useEffect(() => {
        if (needUpdate) {
            reCalculatePrice(false);
            setNeedUpdate && setNeedUpdate(false);
        }
    }, [needUpdate]);

    // 监听更新算价
    useEffect(() => {
        const handler = events.on(UPDATE_PRICE, reCalculatePrice);
        return () => {
            events.off(handler);
        };
    }, []);

    const callbackFuns = useRef<any>();
    const timer = useRef<NodeJS.Timeout>();

    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    const catchCallback = (e: any) => {
        if (e !== null) {
            callbackFuns.current.fail?.();
        }
        reCalculatePrice();
        hideCreateTip();
        editor.enableOperate();
    };

    const checkProcess = (msg_id: string) => {
        fetchPPTCheckItemProcess({ msg_id })
            .then(
                ({
                    data: {
                        data: { success },
                    },
                }) => {
                    if (!success) {
                        clearTimeout(timer.current);
                        timer.current = setTimeout(() => {
                            checkProcess(msg_id);
                        }, 2000);
                    } else {
                        fetchDetail(msg_id);
                    }
                },
            )
            .catch(catchCallback);
    };

    const fetchDetail = (msg_id: string) => {
        fetchPPTItemDetail({ msg_id })
            .then((templateDetail) => {
                const data = templateDetail?.data?.data;
                if (!data || !data.id) {
                    throw Error('error');
                }
                return transferTemplateToClient(templateDetail, editor.font.getList());
            })
            .then(({ template, extraInfo }) => {
                return packageTemplateConf(template.templateConf, extraInfo, false);
            })
            .then(({ stages, extraInfos }) => {
                callbackFuns.current.success?.(stages, extraInfos);
            })
            .catch(catchCallback)
            .finally(() => {
                catchCallback(null);
            });
    };

    return {
        async submit({
            success,
            fail,
            click,
            transferId,
        }: {
            success?: Function;
            fail?: Function;
            click?: Function;
            transferId?: string;
        }) {
            if (!prompt) return;
            click?.();
            setIsAiCreate(false);
            setAiRegen({ isAiRegen: false });
            setPrompt('');
            showCreateTip(tip);
            editor.disableOperate();
            callbackFuns.current = { success, fail };
            fetchPPTApplyItem({
                ...params,
                transfer_id: transferId,
            })
                .then(
                    ({
                        data: {
                            data: { msg_id },
                        },
                    }) => {
                        checkProcess(msg_id);
                    },
                )
                .catch(catchCallback);
        },
    };
};
